import { IconButton, Tooltip } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useTranscriptRequest } from "../../hooks/useTranscription";
import { useAlert } from "../../context/AlertContext";
import { ArticleOutlined } from "@mui/icons-material";

interface TranscriptionActionButtonProps {
  customerId: string;
  interactionId: string;
  hasExistingTranscript?: boolean;
  onTranscriptionStarted?: (jobId: string) => void;
}

export function TranscriptionActionButton({
  customerId,
  interactionId,
  hasExistingTranscript = false,
  onTranscriptionStarted,
}: Readonly<TranscriptionActionButtonProps>) {
  const { mutateAsync: transcribeAsync } = useTranscriptRequest();
  const showAlert = useAlert();
  const { t } = useTranslation(["transcription"]);

  if (hasExistingTranscript) return null;

  const handleRequestTranscript = async () => {
    const result = await transcribeAsync({
      customerId,
      interactionId,
    });
    onTranscriptionStarted?.(result.jobId);
    showAlert(t("transcription:transcriptRequestSubmitted"), "success");
  };

  return (
    <Tooltip title={t("transcription:requestTranscript")}>
      <IconButton onClick={handleRequestTranscript} size="small">
        <ArticleOutlined />
      </IconButton>
    </Tooltip>
  );
}
